import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import PathwaySelector from './components/PathwaySelector';
import SuccessStoryCarousel from './components/SuccessStoryCarousel';
import PlatformMetrics from './components/PlatformMetrics';
import CommunityTestimonials from './components/CommunityTestimonials';
import LanguageToggle from './components/LanguageToggle';
import Footer from './components/Footer';

const Homepage = () => {
  const [currentLanguage, setCurrentLanguage] = useState('ar');

  const pageContent = {
    en: {
      title: "CreatorBridge - Bridge Authentic Voices with Meaningful Brands",
      description: "The premier creator economy platform connecting regional talent with brands seeking genuine cultural engagement. Transform your creativity into sustainable income with professional tools.",
      keywords: "creator economy, influencer marketing, brand campaigns, content creation, Middle East creators, regional marketing, authentic engagement"
    },
    ar: {
      title: "CreatorBridge - اربط الأصوات الأصيلة بالعلامات التجارية المؤثرة",
      description: "منصة اقتصاد المبدعين الرائدة التي تربط المواهب الإقليمية بالعلامات التجارية الساعية للمشاركة الثقافية الحقيقية. حول إبداعك إلى دخل مستدام بأدوات احترافية.",
      keywords: "اقتصاد المبدعين, التسويق المؤثر, حملات العلامات التجارية, إنشاء المحتوى, مبدعو الشرق الأوسط, التسويق الإقليمي, التفاعل الأصيل"
    }
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);

    // Listen for language changes
    const handleLanguageChange = (event) => {
      setCurrentLanguage(event?.detail);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  const content = pageContent?.[currentLanguage];

  return (
    <>
      <Helmet>
        <title>{content?.title}</title>
        <meta name="description" content={content?.description} />
        <meta name="keywords" content={content?.keywords} />
        <meta property="og:title" content={content?.title} />
        <meta property="og:description" content={content?.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://creatorbridge.com" />
        <meta property="og:image" content="https://creatorbridge.com/og-image.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={content?.title} />
        <meta name="twitter:description" content={content?.description} />
        <meta name="twitter:image" content="https://creatorbridge.com/twitter-image.jpg" />
        <link rel="canonical" href="https://creatorbridge.com" />
        <html lang={currentLanguage} dir={currentLanguage === 'ar' ? 'rtl' : 'ltr'} />
      </Helmet>
      <div className={`min-h-screen bg-background ${currentLanguage === 'ar' ? 'rtl' : 'ltr'}`}>
        {/* Header */}
        <Header currentLanguag={currentLanguage} />

        {/* Language Toggle */}
        <LanguageToggle />

        {/* Main Content */}
        <main  className="pt-16">
          {/* Hero Section */}
          <HeroSection currentLanguage={currentLanguage} />

          {/* Pathway Selector */}
          <PathwaySelector />

          {/* Success Story Carousel */}
          <SuccessStoryCarousel />

          {/* Platform Metrics */}
          <PlatformMetrics />

          {/* Community Testimonials */}
          <CommunityTestimonials />
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default Homepage;